module.exports = __webpack_public_path__ + "87027ebaa8b16c8202aa30250aa2eee6.svg";